module.exports = __webpack_public_path__ + "static/jukebox-10701858ab8dae4b396baad895cfea74.jpg";